import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Base from './input-base';

var ZoomReset =
/*#__PURE__*/
function (_Base) {
  _inherits(ZoomReset, _Base);

  function ZoomReset() {
    var _this;

    _classCallCheck(this, ZoomReset);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZoomReset).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a._toggle = function () {
      a.isEnabled() && a.zoomOut();
    };

    return _this;
  }

  _createClass(ZoomReset, [{
    key: "getName",
    value: function getName() {
      return 'zoomResetButton';
    }
  }, {
    key: "configure",
    value: function configure() {
      _get(_getPrototypeOf(ZoomReset.prototype), "configure", this).call(this);

      var a = this,
          b = a.getLinkedParent();
      a.configureButton(), a.disable(), b.registerDependancy([{
        derivedInteraction: ['zoomin', 'zoomout'],
        callback: a.dependancyFn,
        component: a
      }]);
    }
  }, {
    key: "configureButton",
    value: function configureButton() {
      var a = this;
      a.config.skipGraphics || a.setLinkedItem('button', a.createButton({
        icon: 'resetIcon',
        handlers: {
          click: a._toggle
        },
        tooltext: a.config.tooltext,
        state: 'disabled'
      })), a.disable();
    }
  }, {
    key: "enable",
    value: function enable() {
      this.config.state = 'activated', _get(_getPrototypeOf(ZoomReset.prototype), "enable", this).call(this);
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var a,
          b,
          c,
          d,
          e,
          f = this,
          g = f.getFromEnv('chart'),
          h = f.getFromEnv('axesObArr'),
          i = f.config.hookFn,
          j = {};
      h.forEach(function (h) {
        e = h.stack[0];
        e && (g.getFromEnv('animationManager').setAnimationState('zoomOut'), i && i(e.minValue, e.maxValue), h.isY ? (c = e.minValue, d = e.maxValue) : (a = e.minValue, b = e.maxValue, j = f.constructor._getZoomInfo(a, b, h.axis)), h.axis.setVisibleConfig(e.minValue, e.maxValue), h.stack.length = 0);
      }), f._raiseZoomEvents('zoomout', 'zoomreset', Object.assign(j, {
        level: 1,
        startX: a,
        endX: b,
        startY: c,
        endY: d
      })), f.disable();
    }
  }, {
    key: "dependancyFn",
    value: function dependancyFn(a) {
      'zoomin' === a.type ? this.enable() : 'zoomout' === a.type && !this._checkStackLen() && this.disable();
    }
  }]);

  return ZoomReset;
}(Base);

export default ZoomReset;